import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Share2, Sparkles } from "lucide-react";
import api from "@/lib/api";

const PRESETS = ["stress", "career", "money", "procrastination"];

export default function Multiverse() {
  const [topic, setTopic] = useState("stress");
  const [graph, setGraph] = useState(null);
  const navigate = useNavigate();

  const load = (t) => { setTopic(t); api.get(`/content/graph`, { params: { topic: t } }).then((r) => setGraph(r.data)).catch(() => {}); };
  useEffect(() => { load("stress"); }, []);

  const center = topic;
  const others = (graph?.nodes || []).map((n) => n.id).filter((id) => id !== center);
  const W = 720, H = 520, cx = W / 2, cy = H / 2, R = Math.min(W, H) / 2 - 90;

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-head font-extrabold text-3xl sm:text-4xl flex items-center gap-3"><Share2 className="w-8 h-8 text-primary" />Multiverse Mode</h1>
        <p className="text-muted-foreground mt-2">Nothing in life is isolated. Pick a topic and see how it connects across your whole life. Tap any node to travel there.</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button key={p} onClick={() => load(p)} data-testid={`multiverse-${p}`}
            className={`rounded-full px-4 py-2 text-sm font-bold border-2 capitalize transition-colors ${topic === p ? "border-primary bg-primary text-primary-foreground" : "border-border hover:border-primary"}`}>{p}</button>
        ))}
      </div>

      <div className="rounded-lg border border-border bg-card overflow-hidden" data-testid="graph-canvas" style={{ backgroundImage: "radial-gradient(hsl(var(--border)/0.5) 1px, transparent 1px)", backgroundSize: "22px 22px" }}>
        <div className="w-full overflow-x-auto">
          <svg viewBox={`0 0 ${W} ${H}`} className="w-full" style={{ minWidth: 520 }}>
            {others.map((id, i) => {
              const a = (i / others.length) * Math.PI * 2 - Math.PI / 2;
              const x = cx + R * Math.cos(a), y = cy + R * Math.sin(a);
              return <line key={`l${i}`} x1={cx} y1={cy} x2={x} y2={y} stroke="hsl(var(--primary))" strokeOpacity="0.35" strokeWidth="1.5" />;
            })}
            {others.map((id, i) => {
              const a = (i / others.length) * Math.PI * 2 - Math.PI / 2;
              const x = cx + R * Math.cos(a), y = cy + R * Math.sin(a);
              return (
                <g key={id} className="cursor-pointer" onClick={() => load(id)} data-testid={`node-${id.replace(/\s/g,'-')}`}>
                  <circle cx={x} cy={y} r="34" fill="hsl(var(--card))" stroke="hsl(var(--accent))" strokeWidth="2" />
                  <text x={x} y={y} textAnchor="middle" dominantBaseline="middle" fontSize="10" fill="hsl(var(--foreground))" style={{ fontWeight: 600 }}>
                    {id.length > 12 ? id.slice(0, 11) + "…" : id}
                  </text>
                </g>
              );
            })}
            <g className="cursor-pointer" onClick={() => navigate(`/ask`)}>
              <circle cx={cx} cy={cy} r="52" fill="hsl(var(--primary))" />
              <text x={cx} y={cy} textAnchor="middle" dominantBaseline="middle" fontSize="14" fill="hsl(var(--primary-foreground))" style={{ fontWeight: 800, textTransform: "capitalize" }}>{center}</text>
            </g>
          </svg>
        </div>
      </div>

      <button onClick={() => navigate("/ask")} className="inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground font-bold px-5 py-2.5 hover:brightness-110 transition">
        <Sparkles className="w-4 h-4" /> Ask inizio about {center}
      </button>
    </div>
  );
}
